// extracted by mini-css-extract-plugin
module.exports = {"hidden":"v1Result_hidden__oJa1D","textEmphasis":"v1Result_textEmphasis__NjUPS","emptyArea":"v1Result_emptyArea__c4Lbd"};